







































import { Component, Mixins } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { userSetteiFormStore } from '@/store/form/UserSetteiFormStore'
import * as ApiPath from '@/tcw/constant/ApiPath'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'

@Component
export default class UserSetteiForm extends Mixins(FormStoreComponent) {
  private tsuchiTestResult = ''
  private tsuchiTestProcessing = false

  get formName(): string {
    return 'userSetteiForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return userSetteiFormStore
  }
  get keyInfo(): KeyInfo {
    return {}
  }
  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  get isEmptyRecord(): boolean {
    return false
  }

  private async submitTest(): Promise<void> {
    try {
      this.tsuchiTestProcessing = true
      const apiPath = ApiPath.buildPath(ApiPath.Paths.SlackSubmit.test, {
        slackName: String(this.form.slackName)
      })
      await this.getWebApi().call(apiPath, 'GET')
      this.tsuchiTestResult = 'OK'
    } catch (e) {
      this.tsuchiTestResult = '送信失敗。Slack名を見直してください。'
    } finally {
      this.tsuchiTestProcessing = false
    }
  }
  protected async afterSaveProc(): Promise<void> {
    this.clearForm()
    this.tsuchiTestResult = ''
    // 保存後にフォームクリア
    this.$tcw.message({
      type: 'success',
      message: '保存しました'
    })
    this.init()
  }
}
